<template>
  <div>
    <vs-sidebar
      spacer
      position-right
      click-not-close
      parent="body"
      color="primary"
      default-index="1"
      class="add-new-data-sidebar items-no-padding"
      v-model="isSidebarActiveLocal"
    >
      <div class="mt-6 flex items-center justify-between px-6">
        <h4 v-if="message.id">EDITAR</h4>
        <h4 v-else>ADICIONAR</h4>
        <feather-icon
          icon="XIcon"
          class="cursor-pointer"
          @click.stop="isSidebarActiveLocal = false"
        />
      </div>
      <vs-divider class="mb-0"/>

      <VuePerfectScrollbar
        :key="$vs.rtl"
        :messages="settings"
        class="scroll-area--data-list-add-new"
      >
        <div class="p-6">
          <div>
            <div class="w-full">
              <div class="flex w-full justify-between">
                <div v-if="editName || !message.id" class="w-full">
                  <vs-input
                    name="name"
                    label="Título"
                    maxlength="30"
                    class="w-full"
                    v-model="message.name"
                    v-validate="'required'"
                  />
                </div>
                <div v-else>
                  <h4>{{ message.name }}</h4>
                </div>

                <feather-icon
                  icon="EditIcon"
                  class="ml-5"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  v-if="message.from_mutation && !!message.id"
                  @click.stop="setEditName"
                />
              </div>

              <vs-alert color="danger" icon="new_releases" active="true" class="mb-2 mt-4 text-sm" v-show="errors.has('name')">
                <p>Adicione um título para a pesquisa.</p>
              </vs-alert>
            </div>

            <div class="w-full" v-if="message.from_mutation">
              <vs-input
                min=1
                name="number"
                type="number"
                label="Ordem"
                maxlength="30"
                class="w-full mt-5"
                v-validate="'required|regex:^[1-9]+'"
                v-model="message.number"
              />

              <vs-alert color="danger" icon="new_releases" active="true" class="mb-2 mt-4 text-sm" v-show="errors.has('number')">
                <p>Insira uma ordem válida para a pesquisa.</p>
              </vs-alert>
            </div>

            <div class="mt-5">
              <label class="vs-input--label">Mensagem</label>
              <textarea
                rows="10"
                name="value"
                id="wa-message"
                ref="wa-message"
                v-model="message.value"
                v-validate="'required'"
                class="vs-textarea text-area message-text-area"
              />

              <vs-alert color="danger" icon="new_releases" active="true" class="mb-2 mt-4 text-sm" v-show="errors.has('value')">
                <p>Insira uma mensagem.</p>
              </vs-alert>
            </div>
          </div>

          <vs-divider>
            Configurações adicionais
          </vs-divider>

          <vs-collapse class="select-none p-0" accordion>
            <vs-collapse-item>
              <div slot="header" class="flex">
                <feather-icon icon="BarChart2Icon" class="mr-2" svgClasses="h-5 w-5"/>
                <small>Faixa de Notas</small>
              </div>

              <div class="flex align-items-center w-full mt-0">
                <vs-input v-validate="'required|regex:^[0-9]+'" min=0 type="number" class="mr-3" v-model="message.scale.start" label="Início"/>
                <vs-input v-validate="'required|regex:^[0-9]+'" min=0 type="number" class="ml-3" v-model="message.scale.end" label="Fim"/>
              </div>
            </vs-collapse-item>
          </vs-collapse>

          <div class="mt-5">
            <vs-list-header
              class="mt-2"
              color="danger"
              v-if="message.value.length !== 0"
              title="Visualização prévia da mensagem"
            />

            <div v-if="message.value.length !== 0 && !message.value.includes(messageDefault)">
              <small>Caso não haja os parâmetros {{message.scale.start}} e {{message.scale.end}} em sua mensagem, a implementação será feita de forma automática. Segue abaixo a prévia da mensagem:</small>
            </div>

            <div v-if="message.value.length !== 0 && message.value.includes(messageDefault)">
              <small>Segue abaixo um padrão da pesquisa de satisfação:</small>
            </div>

            <div style="font-size: 13px;">
              <div>
                <div v-if="message.value.length !== 0" class="message-bubble mt-5" style="float: right;">
                  <p class="message">{{ message.value }}</p>
                  <br>
                  <p v-if="!message.value.includes(message.scale.start) || !message.value.includes(message.scale.end)">Avalie nosso serviço em uma escala de {{message.scale.start}} a {{message.scale.end}}:</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </VuePerfectScrollbar>

      <div slot="footer" class="flex flex-wrap items-center p-6">
        <vs-button :disabled="!isFormValid" class="mr-6" @click="submitData">
          Salvar
        </vs-button>
        <vs-button color="danger" type="border" @click="isSidebarActiveLocal = false">
          Cancelar
        </vs-button>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import request from '@/http/requests/messages'

export default {
  name: 'messages-view-sidebar',
  components: { VuePerfectScrollbar },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    message: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {
      editName: false,
      scale: { start: '1', end: '10' },
      settings: { maxScrollbarLength: 60, wheelSpeed: .60 },
      messageDefault: 'O seu atendimento foi finalizado e gostaríamos de saber sua opinião sobre nosso serviço, por favor nos dê uma nota de 1 até 10',
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
      return !this.errors.any() && !!this.message.value && !!this.message.name
    }
  },
  watch:{
    isSidebarActive(){
      this.editName = false
    }
  },
  methods: {
    setEditName(){
      this.editName = !this.editName
    },
    insertTagOnText(tag) {
      const that = this
      let tArea = this.$refs['wa-message']

      if (!tag) {
        return
      }

      let startPos = tArea.selectionStart
      let endPos = tArea.selectionEnd
      let cursorPos = startPos
      let tmpStr = tArea.value || ''

      that.message.value = `${tmpStr.substring(0, startPos)}{{${tag}}}` + `${tmpStr.substring(endPos, tmpStr.length)}`

      setTimeout(() => {
        cursorPos += that.campaign.message.length
        tArea.selectionStart = tArea.selectionEnd = cursorPos
        that.$refs['wa-message'].focus()
      }, 10)
    },
    submitData() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.message.id){
            request.update(this.message).then(() => {
              this.$emit('closeSidebar');
              this.$emit('updateMessages');
              this.$vs.notify({
                color: 'success',
                title: 'Alteração da mensagem foi realizada.'
              })
            }).catch((error) => {
              console.error(error)
            })

            return;
          }

          request.add(this.message).then(() => {
            this.$emit('closeSidebar');
            this.$emit('updateMessages');
            this.$vs.notify({
              color: 'success',
              title: 'Mensagem adicionada!'
            })
          }).catch((error) => {
            console.error(error)
          })
        }
      });
    }
  },
  mounted(){
    if (!this.message.scale){
      this.message.scale = this.scale;
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }


}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}

@import "@/assets/scss/vuexy/extraComponents/tree.scss";


.height-auto {
  height: auto !important;
}

.message-text-area {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.tags-wrapper {
  background-color: #f8f8f8;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-bottom-left-radius: 6px !important;
  border-bottom-right-radius: 6px !important;
  border-top: none !important;

  > ul > li {
    display: inline-block;
  }
}

.text-area {
  margin-top: 10px;
  background: #fff;
  height: 200px;
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  resize: none !important;
}

.align-right {
  float: right;
}

.message-bubble {
  color: #fff;
  position: relative;
  display: inline-block;
  padding: 10px;
  background-color: #279dfb;
  border-radius: 10px;
}

.message-bubble::before {
  content: "";
  position: absolute;
  top: 11.3%;
  right: -10px;
  transform: translateY(-40%);
  border-bottom: 23px solid transparent;
  border-left: 20px solid #279dfb;
  border-top: 0px solid transparent;
}

.message-bubble p {
  margin-right: 0;

}

.message {
  white-space: pre-line;
  word-break: break-all;
}
</style>
